import { FormattedMessage } from "react-intl";
import {
  Styled,
  StyledButton,
  StyledContentContainer,
  StyledMessageContainer,
} from "./styles";

interface Props {
  remainingTrialDays: number | null;
  onClickActivateBanner: () => void;
  isFullWidth?: boolean;
}

export const Campaign50PercentDiscountJune2025 = (
  props: Props,
): JSX.Element => {
  const { remainingTrialDays, onClickActivateBanner, isFullWidth } = props;

  return (
    <Styled isFullWidth={isFullWidth || false}>
      <StyledContentContainer>
        <StyledMessageContainer data-testid="activate-message">
          Subscribe within {remainingTrialDays} days,{" "}
          <strong>Save 50%. Forever.</strong>
        </StyledMessageContainer>
        <StyledButton
          mini
          onClick={onClickActivateBanner}
          data-testid="activate-button"
        >
          <FormattedMessage
            id="ads.banner.subscribe_now"
            defaultMessage="Subscribe Now"
          />
        </StyledButton>
      </StyledContentContainer>
    </Styled>
  );
};
